import React from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Button } from '@/theme/index';

interface SetupButtonProps {
  handleClose: () => void;
}

export function SetupButton({ handleClose }: SetupButtonProps) {
  const {
    links: { setupSsoLink },
  } = useAppConstantsContext();

  const handleClick = () => {
    handleClose();
    window.open(setupSsoLink, '_self');
  };

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      sx={{ height: '100%', whiteSpace: 'nowrap', alignSelf: 'center' }}
    >
      Set up Now
    </Button>
  );
}
